module.exports = __webpack_public_path__ + "static/media/red-heart.ae24f0df.svg";